module.exports = __webpack_public_path__ + "static/columnGroups-e85f8dba19f6feda67fe66e407909b9d.gif";